import React, { useCallback, useState } from 'react'
import { Element } from 'react-scroll';
import SectionTitle from '../sectionTitle/SectionTitle';
import Dropzone2 from '../../common/Dropzone2';
import ReactMarkdown from 'react-markdown';
import CopyToClipBoard from '../../common/CopyToClipboard';

const HRAgentResume = () => {
  const [showAnalysis, setShowAnalysis] = useState(false);
	const [analysis, setAnalysis] = useState();
  const [file, setFile] = useState([]);
  const [jobDescription, setJobDescription] = useState();
	const [loading, setLoading] = useState(false);

  const APIURL = process.env.REACT_APP_TALENTBRIDGE_API;

  const onDrop = useCallback( (acceptedFiles) => {
    setFile((prevFiles) => [...prevFiles, ...acceptedFiles]);
  }, [setFile]);

	const handleRemove = (fileToRemove) => {
    setFile((prevFiles) =>
      prevFiles.filter((file) => file !== fileToRemove)
    );
  };

	const getParesedResumeText = async () => {
    let parsedResumeText;
    const formdata = new FormData();
    formdata.append("file", file[0]);
    const requestOptions = {
      method: "POST",
      body: formdata,
      redirect: "follow"
    }
    try {
      const response = await fetch(`${APIURL}/parse-document`, requestOptions);
      parsedResumeText = await response.json();
      // console.log(parsedResumeText);
    } catch (error) {
      console.error(error);
    }
    return parsedResumeText;
  }

  const handleResumeAnalysis = async (e) => {
    e.preventDefault();
		setLoading(true);

		const resumeText = await getParesedResumeText();
		const parsedText = resumeText.text;
		const formdata = new FormData();
		formdata.append("resume", parsedText);
		formdata.append("job_description", jobDescription);
		const requestOptions = {
			method: "POST",
			body: formdata,
			redirect: "follow"
		};
		try {
			const response = await fetch(`${APIURL}/analyze-resume`, requestOptions);
			// const response = await fetch(`${APIURL}/parse-document`, requestOptions);
			if(!response.ok) {
				throw new Error(`HTTP error! status: ${response.status}`);
			}
			const responseText = await response.text();
			const lines = responseText.split('\n');
			let extractedContent = null;
			for (const line of lines) {
				// Check if the line is not empty and starts with the expected prefix
				if (line.trim().startsWith('data: ')) {
					// Remove the "data: " prefix
					const jsonString = line.trim().slice(5);

					// Check if it's the DONE message
					if (jsonString === '[DONE]') {
						// This is the end-of-stream signal, we can stop processing.
						break;
					}

					try {
						const parsedData = JSON.parse(jsonString);
						if (parsedData.analysis && parsedData.analysis.length > 0) {
							extractedContent = parsedData.analysis[0].content;
							break;
						}
					} catch (parseError) {
						console.error('Failed to parse a JSON line:', parseError);
						console.log('Problematic line:', jsonString);
					}
				}
			}
			
			if (extractedContent) {
				// console.log(extractedContent);
				setAnalysis(extractedContent);
			} else {
				console.log("No valid analysis content found in the response.");
			}
			setLoading(false);
			setShowAnalysis(true);
		} catch (error) {
			console.error(error);
			setLoading(false);
			setShowAnalysis(true);
		}
		setLoading(false);
  }

	const resetForm = () => {
		setShowAnalysis(false);
		setAnalysis();
		setJobDescription();
		setFile([]);
	}

  return (
    <>
      <Element
        name="resume-analysis"
        className="datatalent-section-gap home-one-cat"
      >
        <div className="container eduvibe-animated-shape">
          <div className="row g-5 align-items-start">
            <div className="col-12 mt-0 p-0">
              <SectionTitle
                // slogan = "HR Agent"
                classes = "text-center"
                title = "AI-Powered Resume Analysis"
              />
            </div>
            <div className="data-talent-description col-12 mt-4 mx-auto px-0 px-md-4">
              <p className="text-center">
                Get insights on how well your resume matches specific job requirements. AI analyzes keywords, skills, and format to maximize your application success.
              </p>
            </div>
            <div className="col-12 col-lg-6 p-0 px-md-4">
              <div className="border rounded-4 p-4 bg-white">
                <div className="h5">How It Works</div>
                <div className="d-flex flex-row align-items-start">
                  <div className="col-1 tb-icon-bg">
                    1
                  </div>
                  <div className="col-11">
                    <p>
                      <strong>Upload Your Resume</strong><br></br>
                      Upload your resume in PDF, DOC, or DOCX format
                    </p>
                  </div>
                </div>
                <div className="d-flex flex-row align-items-start">
                  <div className="col-1 tb-icon-bg">
                    2
                  </div>
                  <div className="col-11">
                    <p>
                      <strong>Add Job Description</strong><br></br>
                      Paste the job description that you're targeting.
                    </p>
                  </div>
                </div>
                <div className="d-flex flex-row align-items-start">
                  <div className="col-1 tb-icon-bg">
                    <svg className="w-full" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#3EB75E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-lov-id="src\components\ResumeAnalysisSection.tsx:72:18" data-lov-name="CheckCircle" data-component-path="src\components\ResumeAnalysisSection.tsx" data-component-line="72" data-component-file="ResumeAnalysisSection.tsx" data-component-name="CheckCircle" data-component-content="%7B%22className%22%3A%22w-4%20h-4%20text-career-success%22%7D">
                      <path d="M21.801 10A10 10 0 1 1 17 3.335"></path><path d="m9 11 3 3L22 4"></path>
                    </svg>
                  </div>
                  <div className="col-11">
                    <p>
                      <strong>Click "Analyze Resume Match"</strong><br></br>
                      Receive detailed match score and improvement recommendations
                    </p>
                  </div>
                </div>
              </div>
              <div className="border rounded-4 bg-white mt-5 p-4">
                <h5>What You'll Get:</h5>
                <p className="mb-2">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#3EB75E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-lov-id="src\components\ResumeAnalysisSection.tsx:72:18" data-lov-name="CheckCircle" data-component-path="src\components\ResumeAnalysisSection.tsx" data-component-line="72" data-component-file="ResumeAnalysisSection.tsx" data-component-name="CheckCircle" data-component-content="%7B%22className%22%3A%22w-4%20h-4%20text-career-success%22%7D">
                    <path d="M21.801 10A10 10 0 1 1 17 3.335"></path><path d="m9 11 3 3L22 4"></path>
                  </svg>
                  &nbsp;&nbsp;Overall professional assessment
                </p>
                <p className="mb-2">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#3EB75E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-lov-id="src\components\ResumeAnalysisSection.tsx:72:18" data-lov-name="CheckCircle" data-component-path="src\components\ResumeAnalysisSection.tsx" data-component-line="72" data-component-file="ResumeAnalysisSection.tsx" data-component-name="CheckCircle" data-component-content="%7B%22className%22%3A%22w-4%20h-4%20text-career-success%22%7D">
                    <path d="M21.801 10A10 10 0 1 1 17 3.335"></path><path d="m9 11 3 3L22 4"></path>
                  </svg>
                  &nbsp;&nbsp;Missing keywords analysis
                </p>
                <p className="mb-2">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#3EB75E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-lov-id="src\components\ResumeAnalysisSection.tsx:72:18" data-lov-name="CheckCircle" data-component-path="src\components\ResumeAnalysisSection.tsx" data-component-line="72" data-component-file="ResumeAnalysisSection.tsx" data-component-name="CheckCircle" data-component-content="%7B%22className%22%3A%22w-4%20h-4%20text-career-success%22%7D">
                    <path d="M21.801 10A10 10 0 1 1 17 3.335"></path><path d="m9 11 3 3L22 4"></path>
                  </svg>
                  &nbsp;&nbsp;Skills gap identification
                </p>
                <p className="mb-2">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#3EB75E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-lov-id="src\components\ResumeAnalysisSection.tsx:72:18" data-lov-name="CheckCircle" data-component-path="src\components\ResumeAnalysisSection.tsx" data-component-line="72" data-component-file="ResumeAnalysisSection.tsx" data-component-name="CheckCircle" data-component-content="%7B%22className%22%3A%22w-4%20h-4%20text-career-success%22%7D">
                    <path d="M21.801 10A10 10 0 1 1 17 3.335"></path><path d="m9 11 3 3L22 4"></path>
                  </svg>
                  &nbsp;&nbsp;Personalized improvement suggestions
                </p>
                <p className="mb-2">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#3EB75E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-lov-id="src\components\ResumeAnalysisSection.tsx:72:18" data-lov-name="CheckCircle" data-component-path="src\components\ResumeAnalysisSection.tsx" data-component-line="72" data-component-file="ResumeAnalysisSection.tsx" data-component-name="CheckCircle" data-component-content="%7B%22className%22%3A%22w-4%20h-4%20text-career-success%22%7D">
                    <path d="M21.801 10A10 10 0 1 1 17 3.335"></path><path d="m9 11 3 3L22 4"></path>
                  </svg>
                  &nbsp;&nbsp;ATS Keyword recommendation
                </p>
              </div>
            </div>
            <div className="col-12 col-lg-6 p-0 px-md-3">
              <div className="border rounded-4 p-4 bg-white">
                {!showAnalysis ? <>
                  <div className="resume-upload-container">
                    <h5 className="mb-0">Try Resume Analysis</h5>
                    <p className="">Upload your resume to get personalized advice and interview practice.</p>
                    <form onSubmit={handleResumeAnalysis}>
                      <div>
                        <label htmlFor="resumeFile">Upload Resume (.pdf, .doc, .docx)</label><br></br>
                        <Dropzone2 onDrop={onDrop} onRemove={handleRemove} files={file} accept={{"application/msword": [], "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [], "application/pdf": []}} required />
                      </div>
                      {/* {file.length === 0 && <div>
                        <label htmlFor="resumetext">Or paste resume text directly</label><br></br>
                        <textarea rows={5} name="resumetext" placeholder="Paste your resume..." />
                      </div>} */}
                      <div className="mt--40">
                        <label htmlFor="jobDescription">Job Description</label><br></br>
                        <textarea rows={5} name="jobDesription" placeholder="Paste the job description here" value={jobDescription} onChange={(e) => setJobDescription(e.target.value)} required />
                      </div>
                      <button className={`edu-btn btn-secondary mt-4${loading ? " disabled" : file.length === 0 ? " disabled" : jobDescription ? "" : " disabled"}`} type="submit" disabled={loading ? true : file.length === 0 ? true : jobDescription ? false : true}>Analyze Resume Match</button>
                    </form>
                  </div>
                </> : <>
                  <div className="resume-analysis-container rounded-4">
                    <ReactMarkdown>{analysis}</ReactMarkdown>
                  </div>
									<CopyToClipBoard textToCopy={analysis} saveFileName="Resume_Analysis_" />  
									<button className="edu-btn btn-primary mt-5" onClick={resetForm}>Analyze Another</button>
                </>}
								{loading && <div className="loader-overlay mt-4">
								  <img src={`${process.env.PUBLIC_URL}/images/ajax-loader.gif`} alt="loader" />
								</div>}
              </div>
            </div>
          </div>
        </div>
      </Element>
    </>
  )
}

export default HRAgentResume;